import { styled } from '@mui/material/styles';

interface TextAreaProps {
    focused: boolean;
    hovered: boolean;
}

export const Container = styled('div')({
    display: "flex",
    flex: 1,
    alignSelf: "stretch",
    height: "100%",
    width: "100%",
    padding: 0,
    position: "relative"
});

export const StyledTextArea = styled('textarea')<TextAreaProps>(({ focused, hovered }) => ({
    height: "100%",
    width: "100%",
    resize: "none",
    borderRadius: "4px",
    border: focused ? "2px solid #1976d2" : (hovered ? "1px solid #212121" : "1px solid #c2c2c2"),
    outline: focused ? 0 : "initial",
    padding: "8.5px 14px",
    color: "rgba(0, 0, 0, 0.87)",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.4375em",
    letterSpacing: "0.00938em",
    wordBreak: "break-all",
    scrollbarWidth: "thin"
})); 